<template>
    <ConfirmDialog :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '50vw' }"></ConfirmDialog>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div>
                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.auth?.sign_up }}</span></h3>
                        
                        <div v-if="isSuccess" class="p-my-5">
                            <div v-if="successResponse&&successResponse.email">
                                <span style="font-size:larger">{{ $store.state.i18n.messageBundle?.profile?.account_id }}</span>&nbsp;:&nbsp;
                                <strong style="font-size: larger;">{{ successResponse.email }}</strong>
                            </div>
                            <Button class="p-button-primary p-my-2" @click="copyUserIdToClipboard()" :label="$store.state.i18n.messageBundle?.auth?.copy_account_id_to_clipboard"></Button> 
                            <InlineMessage v-if="successResponse&&successResponse.email" severity="success">
                                {{ $store.state.i18n.messageBundle?.auth?.sign_up_success }}&nbsp;<a href="/#/login">{{ $store.state.i18n.messageBundle?.auth?.sign_in_after_sign_up_success }}</a></InlineMessage>
                        </div>
                        <form v-else @submit.prevent="onSubmit" class="p-my-5">
                            <div class="p-fluid">
                                <div class="p-my-3">
                                    <div>
                                        <label for="name" class="account-attr-font" :class="{ 'p-error': v$.name.$invalid && submitted }">
                                            <strong>{{ $store.state.i18n.messageBundle?.profile?.name }}</strong>
                                        </label>
                                        <InputText id="name" :placeholder="$store.state.i18n.messageBundle?.profile?.enter_name" maxLength="50" type="text" v-model="v$.name.$model" class="name-input p-mt-2" :class="{ 'p-invalid': v$.name.$invalid && submitted }" />
                                    </div>
                                    <div>
                                        <small v-if="v$.name.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.profile?.name }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                    
                                    
                                    <div class="p-mb-3"></div>

                                    <div v-if="!(createVirtualEmail&&createVirtualEmail.length>0)">
                                        <label for="newEmail" class="account-attr-font"><strong>{{ $store.state.i18n.messageBundle?.profile?.email }}</strong></label>  
                                                                                                                     
                                        <div class="p-mt-2">
                                            <InputText :disabled="(this.createVirtualEmail&&this.createVirtualEmail.length>0)" 
                                                id="newEmail" :placeholder="$store.state.i18n.messageBundle?.profile?.enter_email" maxLength="50" type="email" v-model="newEmail" class="common-email-input" />
                                        </div>
                                    </div>

                                    <div class="p-mb-1"></div>

                                    <div class="p-field-checkbox">
                                        <Checkbox id="createVirtualEmail" name="createVirtualEmail" value="CREATE_VIRTUAL_EAMIL" v-model="createVirtualEmail" @change="changeVirtualEmailReq" />
                                        <label for="createVirtualEmail" class="p-ml-2">{{ $store.state.i18n.messageBundle?.auth?.sign_up_with_no_email }}</label>
                                    </div>

                                    <div v-if="createVirtualEmail&&createVirtualEmail.length>0">
                                        <p>
                                            <strong>{{ $store.state.i18n.messageBundle?.auth?.sign_up_with_no_email_desc }}</strong>
                                        </p>
                                    </div>

                                    <div class="p-mb-3"></div>
                                    

                                    <div class="p-mb-2">
                                        <label for="phone" class="account-attr-font"><strong>{{ $store.state.i18n.messageBundle?.profile?.phone }}</strong></label>
                                    </div>
                                    <Dropdown
                                        v-model="countryPhoneValue"
                                        :options="countryPhoneValues"
                                        optionLabel="name"
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.country_code+' *'"
                                        :filter="true"
                                        :showClear="true"
                                        @change="updateCountryCode()"
                                        class="multiselect-custom p-mr-3"
                                    >
                                        <template #value="slotProps">
                                            <div class="country-item country-item-value" v-if="slotProps.value">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.value.code.toLowerCase()" />
                                                <div>{{ slotProps.value.name }}</div>
                                            </div>
                                            <template v-else>
                                                {{ slotProps.placeholder }}
                                            </template>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="country-item">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />
                                                <div>{{ slotProps.option.name }}</div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="phone-number-holder">
                                        <InputText style="text-align: right; max-width: 100px;" 
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.country_code" v-model="phoneCountryCode" disabled class="p-mt-3 country-code" :class="{ 'p-invalid': v$.phone.$invalid && submitted }" />
                                        <InputText
                                            id="phone"
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.phone_number+' *'"
                                            v-model="v$.phone.$model"
                                            :disabled="!phoneCountryCode || phoneCountryCode.length < 1"
                                            type="number"
                                            class="p-mt-3 phone-number-input"
                                            :class="{ 'p-invalid': v$.phone.$invalid && submitted }"
                                        />
                                    </div>
                                    <div>
                                        <small v-if="v$.phone.$invalid && submitted" class="p-error p-mt-3">
                                            {{ $store.state.i18n.messageBundle?.profile?.phone }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>

                                    <div class="p-mb-3"></div>

                                    <div>
                                        <label for="newPassword" class="account-attr-font" :class="{ 'p-error': v$.newPassword.$invalid && submitted }"> 
                                            <strong>{{ $store.state.i18n.messageBundle?.auth?.password }}</strong></label>
                                        <div class="p-inputgroup p-mt-2">
                                            <InputText id="newPassword" class="password-input-text-corner" 
                                            :placeholder="$store.state.i18n.messageBundle?.auth?.place_holder?.password" maxLength="50" :type="newPasswordInputType" v-model="v$.newPassword.$model" :class="{ 'p-invalid': v$.newPassword.$invalid && submitted }" />
                                            <Button icon="pi pi-eye" class="input-group-button p-button-info password-input-btn-corner" :disabled="!newPassword" @click="toggleNewPasswordInputType()" />
                                        </div>
                                    </div>
                                    <div>
                                        <small v-if="v$.newPassword.$invalid && submitted" class="p-error">Enter new Password!</small>
                                    </div>
                                    <div class="p-mb-3"></div>
                                    <div>
                                        <label for="confirmPassword" class="account-attr-font" :class="{ 'p-error': v$.confirmPassword.$invalid && submitted }">
                                        <strong>{{ $store.state.i18n.messageBundle?.profile?.confirm_password }}</strong></label>
                                        
                                        <div class="p-inputgroup">
                                            <InputText
                                                id="confirmPassword"
                                                :placeholder="$store.state.i18n.messageBundle?.profile?.enter_confirm_password"
                                                maxLength="50"
                                                :type="confirmPasswordInputType"
                                                v-model="v$.confirmPassword.$model"
                                                class="password-input-text-corner"
                                                :class="{ 'p-invalid': v$.confirmPassword.$invalid && submitted }"
                                            />
                                            <Button icon="pi pi-eye" class="input-group-button p-button-info password-input-btn-corner" :disabled="!confirmPassword" @click="toggleConfirmPasswordInputType()" />
                                        </div>
                                    </div>
                                    <div>
                                        <small v-if="v$.confirmPassword.$invalid && submitted" class="p-error">
                                            {{ $store.state.i18n.messageBundle?.profile?.confirm_password }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>

                                    <div class="p-mb-3"></div>

                                    <div class="p-field-checkbox">
                                        <Checkbox id="accept" name="accept" value="Accept" v-model="v$.accept.$model" :class="{ 'p-invalid': v$.accept.$invalid && submitted }" />
                                        <label for="accept" class="p-ml-2" :class="{ 'p-error': v$.accept.$invalid && submitted }"
                                            >{{ $store.state.i18n.messageBundle?.auth?.sign_up_terms_agreement }}&nbsp;
                                            <a href="/#/terms">{{ $store.state.i18n.messageBundle?.auth?.read_sign_up_terms }}</a></label
                                        >
                                    </div>

                                    <div v-if="captchaPhrase" class="p-my-3"> 
                                        <div><label for="captcha" class="account-attr-font"><strong>CAPTCHA</strong></label></div>                                   
                                        <div class="p-inputgroup" >
                                            <img style="max-height: 50px; width: auto;" class="img-responisve" alt="CAPTCHA" :src="generateCaptchaUrl+'/'+captchaPhrase"/>
                                            <Button icon="pi pi-refresh" class="p-button p-button-info"  style="margin-top: 0;margin-bottom: 0; min-width: auto;" @click="requestCaptcha"></Button>
                                        </div>
                                        <div>
                                            <InputText id="captcha" 
                                            :placeholder="$store.state.i18n.messageBundle?.auth?.place_holder?.enter_captcha"
                                            type="text" v-model="captchaValue" class="common-otp-input otp-input p-mt-2" />
                                        </div>

                                    </div>
                                
                                </div>
                                <div v-if="captchaPhrase">
                                    <Button
                                        :disabled="isProcessing || (captchaValue.length<6) || v$.name.$invalid || v$.phone.$invalid || !phoneCountryCode || !(accept && accept[0] === 'Accept') || submitted"
                                        class="p-button-primary"
                                        @click="registerAccount()"
                                        :label="$store.state.i18n.messageBundle?.common?.submit"
                                    ></Button>
                                </div>
                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">{{ errorMsg }}</InlineMessage>
                                </div>
                            </div>
                        </form>
                        <hr />                        
                        <div class="p-mt-3">
                            <h5>{{ $store.state.i18n.messageBundle?.common?.useful_links }}</h5>
                            <div class="p-mb-3">
                                <a href="/#/login"><span class="pi pi-sign-in"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.sign_in_action }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a href="/#/products"><span class="pi pi-tags"></span>&nbsp;{{ $store.state.i18n.messageBundle?.profile?.useful_links?.view_products }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a href="/#/cart"><span class="pi pi-shopping-cart"></span>&nbsp;{{ $store.state.i18n.messageBundle?.profile?.useful_links?.view_cart }}</a>
                            </div>
                        </div>
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';

export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            user: null,
            newEmail: null,
            name: null,
            phone: null,
            phoneCountryCode: null,
            countryPhoneValue: null,
            countryPhoneValues: [
                //{ name: 'Australia', code: 'AU', phoneCountryCode: '+61' },
                //{name: 'China', code: 'CN', phoneCountryCode: '+86'},
                //{name: 'India', code: 'IN', phoneCountryCode: '+91'},
                { name: 'Myanmar', code: 'MM', phoneCountryCode: '+95' },
                { name: 'Thailand', code: 'TH', phoneCountryCode: '+66' },
                { name: 'Malaysia', code: 'MY', phoneCountryCode: '+60' },
                { name: 'Singapore', code: 'SG', phoneCountryCode: '+65' },
                { name: 'Indonesia ', code: 'ID', phoneCountryCode: '+62' },
                //{ name: 'Philippine', code: 'PH', phoneCountryCode: '+63' },
                //{name: 'Vietnam', code: 'VN', phoneCountryCode: '+84'},
            ],
            newPasswordInputType: 'password',
            showNewPasswordFlag: false,
            confirmPasswordInputType: 'password',
            showConfirmPasswordFlag: false,
            newPassword: null,
            confirmPassword: null,
            accept: null,
            submitted: false,
            isProcessing: false,
            isError: false,
            isSuccess: false,
            errorMsg: '',
            successResponse:null,
            createVirtualEmail:[],
            captchaPhrase:'',
            captchaValue:'',
            regChallenge: '',
            generateCaptchaUrl: process.env.VUE_APP_API_ROOT+'/user/generate-captcha'
        };
    },
    created() {
        this.user = this.$loadUserData(this);

        if (this.user) {
            this.$gotoProfile(this); //go to profile page
        }

        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();
        this.resetForm();
        this.requestCaptcha();
    },
    validations() {
        return {            
            name: {
                required,
            },
            phone: {
                required,
            },
            phoneCountrycode: {
                required,
            },
            newPassword: {
                required,
            },
            confirmPassword: {
                required,
            },
            accept: {
                required,
            },
        };
    },
    methods: {
        async requestCaptcha(){
            let response = await this.authService.reqCaptchaRegister();
            this.utilService.consoleLog('response:', response);
            this.captchaPhrase=response.captchaPhrase;
            this.regChallenge=response.regChallenge;
        },
        registerAccount() {
            console.log('accept:', this.accept);
            this.$confirm.require({
                //message: 'Confirm all your data are correct to proceed.',
                //header: 'Confirmation',
                header: this.$store.state.i18n.messageBundle?.common?.confirmation_title,
                message: this.$store.state.i18n.messageBundle?.common?.confirmation_desc,
                acceptLabel: this.$store.state.i18n.messageBundle?.common?.confirm_yes,
                rejectLabel: this.$store.state.i18n.messageBundle?.common?.confirm_no,
                icon: 'pi pi-check',
                accept: async () => {
                    try {
                        await this.$verifyUserData(this); //ensure user session is valid before sending the request
                        this.isProcessing = true;
                        this.isError = false;
                        this.isSuccess = false;
                        this.submitted = true;
                        let response = await this.authService.performAccountRegistration({
                            email: this.newEmail.toLowerCase().trim(),
                            password: this.newPassword.trim(),
                            confirmPassword: this.confirmPassword.trim(),
                            name: this.name.trim(),
                            phoneCountryCode: this.phoneCountryCode ? this.phoneCountryCode.trim() : '',
                            phone: this.phone ? this.phone.trim() : '',
                            regChallenge:this.regChallenge,
                            captchaPhrase:this.captchaPhrase,
                            captchaValue:this.captchaValue
                        });
                        this.utilService.consoleLog('response:', response);
                        this.successResponse=response;
                        this.isSuccess = true;
                        window.scrollTo(0,0);
                    } catch (err) {
                        let errObject = this.utilService.defineError(err);
                        this.utilService.consoleLog('errObject:', errObject);
                        if (errObject.errorDescription) {
                            this.errorMsg = errObject.errorDescription;
                        } else {
                            this.errorMsg = 'Error occurred while processing request! Please try again later.';
                        }
                        this.isError = true;
                    } finally {
                        this.isProcessing = false;
                        this.submitted = false;
                    }
                },
                reject: () => {
                    this.$confirm.close();
                },
            });
        },
        resetForm() {
            this.name = null;
            this.phone = null;
            this.countryPhoneValue = null;
            this.phoneCountryCode = null;
        },
        updateCountryCode() {
            if (this.countryPhoneValue) {
                this.phoneCountryCode = this.countryPhoneValue.phoneCountryCode;
            } else {
                this.phoneCountryCode = null;
                this.phone = null;
            }
        },
        toggleNewPasswordInputType() {            
            if (this.showNewPasswordFlag) {
                this.showNewPasswordFlag = false;
                this.newPasswordInputType = 'password';
            } else {
                this.showNewPasswordFlag = true;
                this.newPasswordInputType = 'text';
            }
        },
        toggleConfirmPasswordInputType() {            
            if (this.showConfirmPasswordFlag) {
                this.showConfirmPasswordFlag = false;
                this.confirmPasswordInputType = 'password';
            } else {
                this.showConfirmPasswordFlag = true;
                this.confirmPasswordInputType = 'text';
            }
        },
        changeVirtualEmailReq(evt){
            if(this.createVirtualEmail&&this.createVirtualEmail.length>0){
                console.log(this.createVirtualEmail[0]);
                this.newEmail='';
            }
            console.log(evt);
        },
        async copyUserIdToClipboard(){
            try{
                if(this.successResponse){
                    if(this.successResponse.email){
                        await navigator.clipboard.writeText(this.successResponse.email);
                    }else {
                        if(this.successResponse.accKey){
                            await navigator.clipboard.writeText(this.successResponse.accKey);
                        }
                    }
                }
            }catch(err){
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
            }
        }
    },
};
</script>

<style lang="scss" scoped>

.password-input-text-corner {
    border-radius: 3px 0 0 3px !important; 
    border-width: 1px 0 1px 1px !important;
}

.password-input-btn-corner {
    border-radius: 0 3px 3px 0; 
    border-width: 1px 1px 1px 0; 
    border-color: #65656a;
}

.login-body {
    overflow: hidden;
    position: relative;
    background: url("https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 190vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}
.country-item {
    display: flex;
    align-items: center;
}
.country-item img.flag {
    width: 18px;
    margin-right: 0.5rem;
}
.multiselect-custom .country-placeholder {
    padding: 0.25rem;
}
::v-deep(.p-chips .p-chips-token) {
    background-color: var(--primary-color);
    color: var(--primary-color-text);
}
::v-deep(.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token) {
    margin: 0.1rem 0.5rem 0.1rem 0;
}

.p-dropdown {
    width: 100%;
    font-weight: normal;
}

.phone-number-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.country-code {
    width: 25%;
    margin-right: 2px;
}

.phone-number-input {
    width: 75%;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: .95;
    
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 230vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: .95;
        height: 100%;
    }
}
</style>
